export default __webpack_public_path__ + "assets/icon-black-offer-discount.6d4004c1.webp";